export default __webpack_public_path__ + "static/media/tsC.5be0b5eb.webp";